import { render, staticRenderFns } from "./MemberPersonNumDlg.vue?vue&type=template&id=80f9cf84&scoped=true"
import script from "./MemberPersonNumDlg.vue?vue&type=script&lang=js"
export * from "./MemberPersonNumDlg.vue?vue&type=script&lang=js"
import style0 from "./MemberPersonNumDlg.vue?vue&type=style&index=0&id=80f9cf84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f9cf84",
  null
  
)

export default component.exports